// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__v0uz+","active":"navbar_active__EPZsy","li":"navbar_li__YibIV"};